import { CompanyEdit as CompanyEditForm } from 'ui/components/company/patterns/CompanyEdit/CompanyEdit';

/**
 * 売り手企業編集ページ
 */
export const CompanyEdit: React.FC = () => {
    return <CompanyEditForm />;
};
